(function () {
  'use strict';

  // Real kits use 2.5mm drills, so every centimetre of canvas holds 4 drills.
  // A 40x50cm kit is 160 x 200 drills, a 60x80cm kit is 240 x 320 drills.
  // The preview always uses the real drill count for the selected size.
  var DRILLS_PER_CM = 4;
  var FALLBACK_SIZE = [50, 50]; // used only if the product has no Size option
  var MAX_COLORS = 200;         // kits are made in up to 200 colors
  var MAX_CANVAS_PX = 2400;     // longest canvas side; keeps mobile memory safe
  var SATURATION = 1.18;        // punches up color separation pre-quantization
  var CONTRAST = 1.10;          // pivots at mid-gray, so it never adds net brightness

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function init(root) {
    var fileInput = $('.dam-preview-file', root);
    var dropZone = $('.dam-preview-drop', root);
    var frame = $('.dam-preview-frame', root);
    var beforeImg = $('.dam-preview-before-img', root);
    var afterCanvas = $('.dam-preview-after-canvas', root);
    var afterWrap = $('.dam-preview-after-wrap', root);
    var handle = $('.dam-preview-handle', root);
    var handleLine = $('.dam-preview-handle-line', root);
    var status = $('.dam-preview-status', root);
    var drillInfo = $('.dam-preview-drillinfo', root);
    var tryOwnBtn = $('.dam-preview-try-own', root);
    var productImageUrl = root.getAttribute('data-product-image');

    // Visible text comes from the section's settings (data-txt-* attributes)
    // so it can be translated; English fallbacks keep it working if unset.
    function txt(name, fallback) {
      return root.getAttribute('data-txt-' + name) || fallback;
    }
    var T = {
      tryOwn: txt('try-own', 'Try your own photo instead'),
      back: txt('back', 'Back to example photo'),
      loading: txt('loading', 'Loading photo…'),
      converting: txt('converting', 'Turning it into diamond art…'),
      errPreview: txt('err-preview', 'Could not preview that photo. Try a different one.'),
      errPhoto: txt('err-photo', 'Could not read that photo. Try a different one.'),
      errFile: txt('err-file', 'Could not read that file. Try a different one.'),
      drillInfo: txt('drill-info', 'Shown with the real drill count for {size}: {cols} x {rows} drills')
    };

    if (!frame || !afterCanvas) return;

    // ---- which kit size / drill shape is selected ----

    var variants = [];
    try {
      var vEl = $('.dam-preview-variants', root);
      if (vEl) variants = JSON.parse(vEl.textContent) || [];
    } catch (e) { variants = []; }

    function findVariant(id) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return null;
    }

    // The product form's hidden variant input is the source of truth; the
    // ?variant= URL parameter and the section's initial variant are fallbacks.
    function currentVariantId() {
      var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (input && input.value) return input.value;
      var m = /[?&]variant=(\d+)/.exec(window.location.search);
      if (m) return m[1];
      return root.getAttribute('data-initial-variant');
    }

    function parseSize(text) {
      var m = /(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/i.exec(text || '');
      if (!m) return null;
      return [parseFloat(m[1]), parseFloat(m[2])];
    }

    function currentKit() {
      var v = findVariant(currentVariantId()) || variants[0] || {};
      var dims = parseSize(v.size) || FALLBACK_SIZE;
      var round = /round/i.test(v.shape || '');
      return {
        label: v.size || (FALLBACK_SIZE[0] + 'x' + FALLBACK_SIZE[1] + 'cm'),
        dims: dims,
        round: round,
        key: (v.size || '') + '|' + (round ? 'round' : 'square')
      };
    }

    var dragging = false;
    var lastImg = null;
    var lastKitKey = null;

    function setSliderPosition(clientX) {
      var rect = frame.getBoundingClientRect();
      if (!rect.width) return; // frame not laid out yet -- nothing to compute against
      var x = (clientX - rect.left) / rect.width;
      x = Math.max(0, Math.min(1, x));
      var pct = x * 100;
      var clip = 'inset(0 0 0 ' + pct + '%)';
      afterWrap.style.clipPath = clip;
      afterWrap.style.webkitClipPath = clip;
      handle.style.left = pct + '%';
      handleLine.style.left = pct + '%';
    }

    // Centers the handle once the frame has actually been laid out. Calling
    // getBoundingClientRect() in the same tick as toggling the frame visible
    // can still race the browser's layout pass and return a zero-width rect
    // (which breaks the position math above) -- waiting two animation
    // frames guarantees a layout has happened in between.
    function centerSliderWhenReady() {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          var rect = frame.getBoundingClientRect();
          setSliderPosition(rect.left + rect.width * 0.5);
        });
      });
    }

    handle.addEventListener('mousedown', function () { dragging = true; });
    handle.addEventListener('touchstart', function () { dragging = true; }, { passive: true });
    window.addEventListener('mouseup', function () { dragging = false; });
    window.addEventListener('touchend', function () { dragging = false; });
    window.addEventListener('mousemove', function (e) {
      if (!dragging) return;
      setSliderPosition(e.clientX);
    });
    window.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      setSliderPosition(e.touches[0].clientX);
    }, { passive: true });
    frame.addEventListener('click', function (e) {
      setSliderPosition(e.clientX);
    });

    if (dropZone && fileInput) {
      dropZone.addEventListener('click', function () { fileInput.click(); });
      dropZone.addEventListener('dragover', function (e) {
        e.preventDefault();
        dropZone.classList.add('dam-preview-drop--over');
      });
      dropZone.addEventListener('dragleave', function () {
        dropZone.classList.remove('dam-preview-drop--over');
      });
      dropZone.addEventListener('drop', function (e) {
        e.preventDefault();
        dropZone.classList.remove('dam-preview-drop--over');
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
          handleFile(e.dataTransfer.files[0]);
        }
      });
    }

    if (fileInput) {
      fileInput.addEventListener('change', function () {
        if (fileInput.files && fileInput.files[0]) {
          handleFile(fileInput.files[0]);
        }
      });
    }

    if (tryOwnBtn) {
      if (!productImageUrl) {
        // No product photo to fall back to -- the placeholder dropzone is
        // already the only upload path, so this button would be redundant.
        tryOwnBtn.style.display = 'none';
      } else {
        tryOwnBtn.addEventListener('click', function () {
          if (root.classList.contains('dam-preview--own-photo')) {
            // Currently showing a personal photo -- switch back to the example.
            root.classList.remove('dam-preview--own-photo');
            if (fileInput) fileInput.value = '';
            tryOwnBtn.textContent = T.tryOwn;
            loadFromUrl(productImageUrl);
          } else {
            root.classList.remove('dam-preview--active');
            root.classList.add('dam-preview--own-photo');
            if (fileInput) fileInput.value = '';
            setStatus('');
            setDrillInfo('');
          }
        });
      }
    }

    function setStatus(text) {
      if (status) status.textContent = text || '';
    }

    function setDrillInfo(text) {
      if (drillInfo) drillInfo.textContent = text || '';
    }

    // Converts the given image at the currently selected kit size and shape.
    function render(img) {
      var kit = currentKit();
      var grid = renderDiamondPreview(img, afterCanvas, kit);
      lastImg = img;
      lastKitKey = kit.key;
      setDrillInfo(T.drillInfo
        .replace('{size}', kit.label)
        .replace('{cols}', grid.cols)
        .replace('{rows}', grid.rows));
    }

    function handleFile(file) {
      if (!file || file.type.indexOf('image/') !== 0) return;
      setStatus(T.loading);
      var reader = new FileReader();
      reader.onload = function (e) {
        var img = new Image();
        img.onload = function () {
          beforeImg.src = e.target.result;
          frame.style.aspectRatio = img.naturalWidth + ' / ' + img.naturalHeight;
          root.classList.add('dam-preview--active');
          centerSliderWhenReady();
          setStatus(T.converting);
          window.setTimeout(function () {
            try {
              render(img);
              setStatus('');
              if (tryOwnBtn && productImageUrl) tryOwnBtn.textContent = T.back;
            } catch (err) {
              setStatus(T.errPreview);
            }
          }, 30);
        };
        img.onerror = function () { setStatus(T.errPhoto); };
        img.src = e.target.result;
      };
      reader.onerror = function () { setStatus(T.errFile); };
      reader.readAsDataURL(file);
    }

    // Auto-loads the product's own scene photo (the plain photo, not the
    // before/after composite -- the section picks that in Liquid) so shoppers
    // see the conversion instantly, no upload required. crossOrigin is needed
    // because we read pixel data off this image via canvas -- Shopify's CDN
    // serves images with permissive CORS headers.
    function loadFromUrl(url) {
      if (!url) return;
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        beforeImg.src = url;
        frame.style.aspectRatio = img.naturalWidth + ' / ' + img.naturalHeight;
        root.classList.add('dam-preview--active');
        centerSliderWhenReady();
        setStatus(T.converting);
        window.setTimeout(function () {
          try {
            render(img);
            setStatus('');
          } catch (err) {
            // Cross-origin pixel read blocked or another failure -- fail
            // quietly rather than showing a broken canvas; the plain
            // "before" photo and upload option still work.
            setStatus('');
            setDrillInfo('');
            root.classList.remove('dam-preview--active');
          }
        }, 30);
      };
      img.onerror = function () { /* leave initial state, upload still works */ };
      img.src = url;
    }

    // Re-render when the shopper picks a different size or drill shape. The
    // theme updates the form's variant input after its own async work, so a
    // light poll is the most reliable signal across theme versions.
    function checkVariant() {
      if (!lastImg) return;
      if (!root.classList.contains('dam-preview--active')) return;
      var kit = currentKit();
      if (kit.key === lastKitKey) return;
      setStatus(T.converting);
      window.setTimeout(function () {
        try { render(lastImg); setStatus(''); } catch (err) { setStatus(T.errPreview); }
      }, 30);
    }
    if (variants.length) {
      document.addEventListener('change', function () {
        window.setTimeout(checkVariant, 120);
        window.setTimeout(checkVariant, 800);
      }, true);
      window.setInterval(checkVariant, 1000);
    }

    // ---- core conversion pipeline ----

    // Drill grid for this photo at the selected kit size: the kit's long side
    // follows the photo's long side, and the other side follows the photo's
    // own shape, at 4 drills per cm.
    function gridFor(w, h, dims) {
      var longCm = Math.max(dims[0], dims[1]);
      var cols, rows;
      if (w >= h) {
        cols = Math.round(longCm * DRILLS_PER_CM);
        rows = Math.max(1, Math.round(cols * (h / w)));
      } else {
        rows = Math.round(longCm * DRILLS_PER_CM);
        cols = Math.max(1, Math.round(rows * (w / h)));
      }
      return { cols: cols, rows: rows };
    }

    function renderDiamondPreview(img, outCanvas, kit) {
      var w = img.naturalWidth;
      var h = img.naturalHeight;
      var grid = gridFor(w, h, kit.dims);
      var gridCols = grid.cols;
      var gridRows = grid.rows;

      var small = progressiveDownsample(img, w, h, gridCols, gridRows);
      var ctxSmall = small.getContext('2d');
      var imageData = ctxSmall.getImageData(0, 0, gridCols, gridRows);
      applyContrastSaturation(imageData.data, CONTRAST, SATURATION);
      var palette = quantizeMedianCut(imageData.data, gridCols * gridRows, MAX_COLORS);

      var cell = Math.floor(MAX_CANVAS_PX / Math.max(gridCols, gridRows));
      cell = Math.max(4, Math.min(10, cell));
      outCanvas.width = gridCols * cell;
      outCanvas.height = gridRows * cell;
      var ctx = outCanvas.getContext('2d');
      var out = ctx.createImageData(outCanvas.width, outCanvas.height);
      drawDrills(out, palette.assigned, gridCols, gridRows, cell, kit.round);
      ctx.putImageData(out, 0, 0);
      return grid;
    }

    // Per-pixel pattern for one drill, computed once per render and stamped
    // onto every cell. Square drills sit edge to edge with a thin dark seam;
    // round drills leave small dark gaps at the corners. A soft diagonal
    // gradient and a tiny glint read as a faceted resin drill. The gradient
    // is symmetric so it never washes the image out overall.
    function drillPattern(cell, round) {
      var n = cell * cell;
      var kind = new Uint8Array(n);   // 0 = drill, 1 = seam/gap
      var shade = new Float32Array(n);
      var glint = new Uint8Array(n);
      var c = (cell - 1) / 2;
      var radius = cell * 0.5;
      for (var py = 0; py < cell; py++) {
        for (var px = 0; px < cell; px++) {
          var i = py * cell + px;
          if (round) {
            var dx = px - c, dy = py - c;
            if (Math.sqrt(dx * dx + dy * dy) > radius) kind[i] = 1;
          } else if (px === cell - 1 || py === cell - 1) {
            kind[i] = 1;
          }
          shade[i] = ((c - px) + (c - py)) / cell * 10;
          if (cell >= 6) {
            var gx = round ? Math.round(c - cell * 0.18) : 1;
            if ((px === gx || px === gx + 1) && (py === gx || py === gx + 1)) glint[i] = 1;
          }
        }
      }
      return { kind: kind, shade: shade, glint: glint };
    }

    function drawDrills(out, colors, cols, rows, cell, round) {
      var data = out.data;
      var stride = out.width * 4;
      var pat = drillPattern(cell, round);
      var seamMix = round ? 0.5 : 0.45;
      for (var r = 0; r < rows; r++) {
        for (var col = 0; col < cols; col++) {
          var k = (r * cols + col) * 3;
          var cr = colors[k], cg = colors[k + 1], cb = colors[k + 2];
          var base = (r * cell) * stride + (col * cell) * 4;
          for (var py = 0; py < cell; py++) {
            var rowStart = base + py * stride;
            for (var px = 0; px < cell; px++) {
              var i = py * cell + px;
              var o = rowStart + px * 4;
              var R, G, B;
              if (pat.kind[i]) {
                R = cr * (1 - seamMix) + 40 * seamMix;
                G = cg * (1 - seamMix) + 25 * seamMix;
                B = cb * (1 - seamMix) + 20 * seamMix;
              } else {
                var s = pat.shade[i] + (pat.glint[i] ? 26 : 0);
                R = cr + s; G = cg + s; B = cb + s;
              }
              data[o] = R < 0 ? 0 : (R > 255 ? 255 : R);
              data[o + 1] = G < 0 ? 0 : (G > 255 ? 255 : G);
              data[o + 2] = B < 0 ? 0 : (B > 255 ? 255 : B);
              data[o + 3] = 255;
            }
          }
        }
      }
    }

    // Contrast pivots at mid-gray (128) so it darkens shadows exactly as
    // much as it brightens highlights, and saturation pivots on each
    // pixel's own luma, so overall brightness is preserved.
    function applyContrastSaturation(data, contrast, saturation) {
      for (var i = 0; i < data.length; i += 4) {
        var r = data[i], g = data[i + 1], b = data[i + 2];

        r = (r - 128) * contrast + 128;
        g = (g - 128) * contrast + 128;
        b = (b - 128) * contrast + 128;

        var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b;
        r = luma + (r - luma) * saturation;
        g = luma + (g - luma) * saturation;
        b = luma + (b - luma) * saturation;

        data[i] = r < 0 ? 0 : (r > 255 ? 255 : r);
        data[i + 1] = g < 0 ? 0 : (g > 255 ? 255 : g);
        data[i + 2] = b < 0 ? 0 : (b > 255 ? 255 : b);
      }
    }

    // Halves the image down repeatedly (proper area-averaging on each halving
    // step) before the final resize to the exact grid size -- this is what
    // avoids the noisy/speckled look of a single naive nearest-neighbor resize.
    function progressiveDownsample(img, w, h, targetW, targetH) {
      var cw = w, ch = h;
      var src = document.createElement('canvas');
      src.width = cw; src.height = ch;
      var sctx = src.getContext('2d');
      sctx.imageSmoothingEnabled = true;
      sctx.drawImage(img, 0, 0, cw, ch);

      while (cw * 0.5 > targetW && ch * 0.5 > targetH) {
        var nw = Math.max(targetW, Math.round(cw * 0.5));
        var nh = Math.max(targetH, Math.round(ch * 0.5));
        var next = document.createElement('canvas');
        next.width = nw; next.height = nh;
        var nctx = next.getContext('2d');
        nctx.imageSmoothingEnabled = true;
        nctx.imageSmoothingQuality = 'high';
        nctx.drawImage(src, 0, 0, cw, ch, 0, 0, nw, nh);
        src = next;
        cw = nw; ch = nh;
      }

      var final = document.createElement('canvas');
      final.width = targetW; final.height = targetH;
      var fctx = final.getContext('2d');
      fctx.imageSmoothingEnabled = true;
      fctx.imageSmoothingQuality = 'high';
      fctx.drawImage(src, 0, 0, cw, ch, 0, 0, targetW, targetH);
      return final;
    }

    // Median-cut color quantization, no dithering (a real drill is one solid
    // color, so dithering two colors together is never physically accurate).
    function quantizeMedianCut(rgba, pixelCount, maxColors) {
      var indices = new Uint32Array(pixelCount);
      for (var i = 0; i < pixelCount; i++) indices[i] = i;

      var boxes = [{ indices: indices, done: false }];

      function boxRange(box) {
        var minR = 255, maxR = 0, minG = 255, maxG = 0, minB = 255, maxB = 0;
        for (var i = 0; i < box.indices.length; i++) {
          var p = box.indices[i] * 4;
          var r = rgba[p], g = rgba[p + 1], b = rgba[p + 2];
          if (r < minR) minR = r; if (r > maxR) maxR = r;
          if (g < minG) minG = g; if (g > maxG) maxG = g;
          if (b < minB) minB = b; if (b > maxB) maxB = b;
        }
        var rR = maxR - minR, gR = maxG - minG, bR = maxB - minB;
        var channel = 0, range = rR;
        if (gR > range) { channel = 1; range = gR; }
        if (bR > range) { channel = 2; range = bR; }
        return { channel: channel, range: range };
      }

      while (boxes.length < maxColors) {
        var splitIdx = -1, bestScore = -1;
        for (var b = 0; b < boxes.length; b++) {
          if (boxes[b].done || boxes[b].indices.length < 2) continue;
          var score = boxes[b].indices.length; // split the most populous box
          if (score > bestScore) { bestScore = score; splitIdx = b; }
        }
        if (splitIdx === -1) break; // nothing left that can be usefully split

        var box = boxes[splitIdx];
        var info = boxRange(box);
        if (info.range === 0) {
          // flat box (single color) -- mark it done instead of re-queuing,
          // so it's never picked again and the loop can't spin forever.
          box.done = true;
          continue;
        }
        var channel = info.channel;
        var arr = Array.prototype.slice.call(box.indices);
        arr.sort(function (ia, ib) {
          return rgba[ia * 4 + channel] - rgba[ib * 4 + channel];
        });
        var mid = Math.floor(arr.length / 2);
        var boxA = { indices: Uint32Array.from(arr.slice(0, mid)), done: false };
        var boxB = { indices: Uint32Array.from(arr.slice(mid)), done: false };
        boxes.splice(splitIdx, 1, boxA, boxB);
      }

      var assigned = new Uint8ClampedArray(pixelCount * 3);
      for (var bi = 0; bi < boxes.length; bi++) {
        var bx = boxes[bi];
        var sr = 0, sg = 0, sb = 0;
        for (var j = 0; j < bx.indices.length; j++) {
          var pp = bx.indices[j] * 4;
          sr += rgba[pp]; sg += rgba[pp + 1]; sb += rgba[pp + 2];
        }
        var n = bx.indices.length || 1;
        var avgR = Math.round(sr / n), avgG = Math.round(sg / n), avgB = Math.round(sb / n);
        for (var k = 0; k < bx.indices.length; k++) {
          var pi = bx.indices[k];
          assigned[pi * 3] = avgR;
          assigned[pi * 3 + 1] = avgG;
          assigned[pi * 3 + 2] = avgB;
        }
      }

      return { assigned: assigned, colorCount: boxes.length };
    }

    // Kick off automatically with the product's own photo, if present.
    if (productImageUrl) {
      loadFromUrl(productImageUrl);
    }

    return {
      handleFile: handleFile
    };
  }

  function boot() {
    var roots = document.querySelectorAll('.dam-preview');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
